import { END_RULE_TYPE } from '../constants/endRulesTypes'
import { REPEAT_MODE } from '../constants/repeatTypes'

export const MAX_SERIES_OCCURRENCES_FOR_SUBDAY_REPEAT = 500
export const MAX_MINUTE_REPEAT_INTERVAL = 60
export const MAX_HOUR_REPEAT_INTERVAL = 168

const afterNOccurrenceRuleIndex = schedule =>
  (schedule?.endRules?.rules || []).findIndex(
    item => item.type === END_RULE_TYPE.afterNOccurrences || item.type === 'after_n_occurrences',
  )

const afterNOccurrenceCount = schedule => {
  const rules = schedule?.endRules?.rules || []
  const index = afterNOccurrenceRuleIndex(schedule)
  const rule = index >= 0 ? rules[index] : null
  const count = rule?.count
  return count != null ? Number(count) : null
}

export const validateHighFrequencyRepeatLimits = (schedule, scheduleIndex) => {
  const errors = {}
  const mode = schedule?.repeat?.mode
  const prefix = `schedules.${scheduleIndex}.repeat`
  if (mode !== REPEAT_MODE.everyNMinutes && mode !== REPEAT_MODE.everyNHours) {
    return errors
  }

  const interval =
    mode === REPEAT_MODE.everyNMinutes
      ? Number(schedule.repeat?.intervalMinutes)
      : Number(schedule.repeat?.intervalHours)

  if (mode === REPEAT_MODE.everyNMinutes) {
    if (!interval || interval < 1 || interval > MAX_MINUTE_REPEAT_INTERVAL) {
      errors[`${prefix}.intervalMinutes`] = `Enter minutes between 1 and ${MAX_MINUTE_REPEAT_INTERVAL}.`
    }
  } else if (!interval || interval < 1 || interval > MAX_HOUR_REPEAT_INTERVAL) {
    errors[`${prefix}.intervalHours`] = `Enter hours between 1 and ${MAX_HOUR_REPEAT_INTERVAL}.`
  }

  const ruleIndex = afterNOccurrenceRuleIndex(schedule)
  const occurrences = afterNOccurrenceCount(schedule)
  const endRulesPrefix = `schedules.${scheduleIndex}.endRules`
  const countKey =
    ruleIndex >= 0 ? `${endRulesPrefix}.rules.${ruleIndex}.count` : endRulesPrefix

  if (occurrences == null || !Number.isFinite(occurrences) || occurrences < 1) {
    errors[countKey] =
      ruleIndex >= 0
        ? 'Enter how many occurrences end the series.'
        : 'Add series end “After N occurrences” for minute- or hour-based repeat.'
  } else if (occurrences > MAX_SERIES_OCCURRENCES_FOR_SUBDAY_REPEAT) {
    errors[countKey] =
      `After N occurrences cannot exceed ${MAX_SERIES_OCCURRENCES_FOR_SUBDAY_REPEAT} for minute- or hour-based repeat.`
  }

  return errors
}
